import { render } from "./simulatore.vue?vue&type=template&id=42459929&scoped=true&ts=true"
import script from "./simulatore.vue?vue&type=script&lang=ts"
export * from "./simulatore.vue?vue&type=script&lang=ts"

import "./simulatore.vue?vue&type=style&index=0&id=42459929&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42459929"]])

export default __exports__